﻿import { useEffect } from 'react';

const useEscape = (params: { action: () => void }): void => {

    const checkEscape = (e: KeyboardEvent) => {

        if (e.key === 'Escape') {

            params.action();

        }

    };

    useEffect(() => {

        document.addEventListener('keydown', checkEscape);

        return () => document.removeEventListener('keydown', checkEscape);

    }, []);

};

export { useEscape };
